import styled from 'styled-components';

export const Cont = styled.div`
    background-color: #535353;
    border-style: solid;
    border-color: #434343;
    border-width: 15px 2px 2px 2px;
    min-width: 300px;
`;